export default __webpack_public_path__ + "static/media/480_dummy2016-restaurant02-de.7e7a3631.png";